import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaAngleLeft } from "react-icons/fa";
import { getTeamDetails } from "../../../../redux/actions/campaignActions";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import "../../../new/new.scss";

const Viewteam = () => {
  let token = localStorage.getItem("accessToken");
  const id = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const teamView = useSelector((state) => state.teamView);
  const { team } = teamView;

  useEffect(() => {
    if (teamView) {
      if (teamView?.loading !== undefined) {
        setLoading(teamView?.loading);
      }
    }
  }, [teamView]);

  useEffect(() => {
    dispatch(getTeamDetails(token, id, navigate));
  }, [dispatch]);

  return (
    <div className="new">
      <Loader isLoading={loading} />
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <span className="backarrow">
            <FaAngleLeft onClick={() => navigate(-1)} />
          </span>
          <h1 className="view-page-tittle">View Team</h1>
        </div>
        <div className="bottom">
          <div className="left">
            <div className="profile-pic-div">
              <img
                src={team?.data?.profile_pic}
                alt=""
                className="setting-profile"
              />
            </div>
          </div>
          <div className="right">
            <form>
              <div className="formInput">
                <label>First Name</label>
                <input
                  type="text"
                  name="firstname"
                  disabled={true}
                  value={team?.data?.firstname}
                  placeholder="Enter First Name"
                />
              </div>
              <div className="formInput">
                <label>Last Name</label>
                <input
                  type="text"
                  name="lastname"
                  disabled={true}
                  value={team?.data?.lastname}
                  placeholder="Enter Last Name"
                />
              </div>
              <div className="formInput">
                <label>Designation</label>
                <input
                  type="text"
                  name="profile_designation"
                  disabled={true}
                  value={team?.data?.profile_designation}
                  placeholder="Enter Designation"
                />
              </div>

              


              <div className="formInput">
                <label>Gmail Link</label>
                <input
                  type="email"
                  name="email"
                  disabled={true}
                  value={team?.data?.gmail_handle}
                  placeholder="Enter Email"
                />
              </div>

              <div className="formInput">
                <label>Role</label>
                <input
                  type="text"
                  name="role"
                  disabled={true}
                  value={team?.data?.role}
                  placeholder="Enter Role"
                />
              </div>

              <div className="formInput">
                <label>LinkedIn Link</label>
                <input
                  type="text"
                  name="linkedin"
                  disabled={true}
                  value={team?.data?.linkdin_handle}
                  placeholder="Enter LinkedIn"
                />
              </div>

              <div className="formInput">
                <label>Facebook Link</label>
                <input
                  type="text"
                  name="facebook"
                  disabled={true}
                  value={team?.data?.facebook_handle}
                  placeholder="Enter LinkedIn"
                />
              </div>

              <div className="formInput">
                <label>Education</label>
                <input
                  type="text"
                  name="education"
                  disabled={true}
                  value={team?.data?.education}
                  placeholder="Enter Education"
                />
              </div>
              <div className="formInput">
                <label>Display Order</label>
                <input
                  type="text"
                  name="order_no"
                  disabled={true}
                  value={team?.data?.order_no}
                  placeholder="Enter Order No"
                />
              </div>
              <div className="formInput">
                <label>English Description</label>

                <textarea
                  type="text"
                  disabled={true}
                  className="description-textarea"
                  value={team?.data?.en_profile}
                  name="about_profile"
                  // cols="47"
                  // rows="5"
                  placeholder="Enter Bio"
                ></textarea>
              </div>
              <div className="formInput">
                <label>Italian Description</label>

                <textarea
                  type="text"
                  disabled={true}
                  className="description-textarea"
                  value={team?.data?.it_profile}
                  name="it_profile"
                  // cols="47"
                  // rows="5"
                  placeholder="Enter Bio"
                ></textarea>
              </div>
              <div className="formInput">
                <label>French Description</label>

                <textarea
                  type="text"
                  disabled={true}
                  className="description-textarea"
                  value={team?.data?.fr_profile}
                  name="fr_profile"
                  // cols="47"
                  // rows="5"
                  placeholder="Enter Bio"
                ></textarea>
              </div>
              <div className="formInput">
                <label>Spanish Description</label>

                <textarea
                  type="text"
                  disabled={true}
                  className="description-textarea"
                  value={team?.data?.es_profile}
                  name="es_profile"
                  // cols="47"
                  // rows="5"
                  placeholder="Enter Bio"
                ></textarea>
              </div>
              <div className="formInput">
                <label>Polish Description</label>

                <textarea
                  type="text"
                  disabled={true}
                  className="description-textarea"
                  value={team?.data?.pl_profile}
                  name="es_profile"
                  // cols="47"
                  // rows="5"
                  placeholder="Enter Bio"
                ></textarea>
              </div>
              <div className="formInput"></div>
              {/* <button type="submit" disabled={true} className="submitBtn">
                Save
              </button> */}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Viewteam;
